/**
 * i18n minimo F1.
 *
 * Regra dura: nenhuma string visivel ao usuario pode viver fora deste arquivo.
 * Content-Designer edita as strings aqui; Frontend-Engineer apenas consome `t()`.
 *
 * Quando a primeira lingua alem de pt-BR entrar, esta camada ganha um seletor
 * de locale. Em F1 pt-BR e a unica.
 */

export const ptBR = {
  app: {
    name: 'CROSS Flux',
    brandName: 'CROSS Flux',
    tagline: 'Seu espelho de negocio em um lugar so.',
  },
  common: {
    email: 'E-mail',
    password: 'Senha',
    submit: 'Enviar',
    loading: 'Carregando...',
    error: 'Algo deu errado. Tente novamente.',
    forbidden: 'Voce nao tem permissao para esta acao.',
    save: 'Salvar',
    continue: 'Continuar',
    back: 'Voltar',
    optional: 'opcional',
    comingSoon: 'Conectar em breve',
  },
  nav: {
    dashboard: 'Painel',
    settings: 'Ajustes',
    logout: 'Sair',
    mirror: 'Espelho do Negocio',
    fourPs: 'Painel',
    chat: 'Perguntar ao CROSS Flux',
    sources: 'Fontes de Dados',
    billing: 'Meu Plano',
    radar: 'Saude do Marketing',
    insights: 'Descobertas',
    settingsShort: 'Configuracoes',
    primaryNav: 'Navegacao principal',
    digital: 'Canais Digitais',
    report: 'Relatorios',
    /* Grupos do rail */
    groupOperation: 'OPERACAO DIARIA',
    groupAnalysis: 'ANALISE',
    groupAdmin: 'ADMINISTRACAO',
  },
  topbar: {
    greetingMorning: 'Bom dia, {name}',
    greetingAfternoon: 'Boa tarde, {name}',
    greetingEvening: 'Boa noite, {name}',
    proactiveNeutral: 'Bem-vindo ao CROSS.',
    proactiveAlerts: '{count} ponto de atencao hoje.',
    proactiveAlertsPlural: '{count} pontos de atencao hoje.',
    freshnessLabel: 'Atualizado hoje {time}',
    periodAriaLabel: 'Periodo de analise',
    sourceAriaLabel: 'Fonte de dados',
    period30d: 'Ultimos 30 dias',
    period7d: 'Ultimos 7 dias',
    period90d: 'Ultimos 90 dias',
    periodYear: 'Ultimo ano',
    sourceAll: 'Todas as fontes',
    sourceInstagram: 'Instagram',
    sourceMetaAds: 'Meta Ads',
    sourceDrive: 'Planilhas do Drive',
    avatarAriaLabel: 'Menu do usuario',
    brandAriaLabel: 'CROSS — pagina inicial',
  },
  signup: {
    title: 'Criar conta',
    subtitle: 'Comece em menos de 2 minutos.',
    submit: 'Criar conta',
    alreadyHaveAccount: 'Ja tem conta? Entrar',
    emailLabel: 'Seu e-mail de trabalho',
    passwordLabel: 'Senha (minimo 8 caracteres)',
    successMessage: 'Conta criada. Verifique seu e-mail para confirmar e continuar.',
  },
  login: {
    title: 'Entrar',
    subtitle: 'Bem-vindo de volta.',
    submit: 'Entrar',
    noAccount: 'Nao tem conta? Criar agora',
    emailLabel: 'E-mail',
    passwordLabel: 'Senha',
    invalidCredentials: 'E-mail ou senha incorretos.',
    unavailable: 'Nao consegui falar com o servidor. Tente de novo em instantes.',
    tooManyAttempts: 'Muitas tentativas seguidas. Aguarde um minuto e tente de novo.',
    forgotPassword: 'Esqueci minha senha',
    showPassword: 'Mostrar senha',
    hidePassword: 'Ocultar senha',
  },
  onboarding: {
    title: 'Vamos configurar seu espaco',
    subtitle: 'Comece com um espaco de trabalho. Depois voce conecta suas fontes.',
    tenantNameLabel: 'Nome do seu negocio ou espaco',
    tenantNamePlaceholder: 'Ex: Casa de Bolos Belem',
    segmentLabel: 'Qual o tipo do seu negocio?',
    segmentOptions: {
      construtora: 'Construtora / Incorporadora',
      hotel: 'Hotel / Pousada',
      escola: 'Escola / Curso',
      loja: 'Loja / Varejo',
      agencia: 'Agencia de marketing',
      franquia: 'Franquia',
      outro: 'Outro',
    },
    sourcesTitle: 'Conecte suas fontes (opcional)',
    sourcesSubtitle:
      'Voce pode pular agora e conectar depois. Recomendamos pelo menos uma para ver valor ja no primeiro dia.',
    sources: {
      instagram: 'Instagram Business',
      metaAds: 'Meta Ads',
      googleDrive: 'Google Drive / Planilhas',
    },
    continueButton: 'Concluir e ir ao painel',
    skipButton: 'Pular por agora',
    stepWorkspace: 'Seu espaco',
    stepSegment: 'Seu negocio',
    stepSources: 'Suas fontes',
    stepCollecting: 'Coletando dados',
    workspaceTitle: 'Como voce chama seu negocio?',
    workspaceSubtitle: 'Esse nome aparece so para voce. Pode mudar depois em Ajustes.',
    segmentTitle: 'Qual o tipo do seu negocio?',
    segmentSubtitle:
      'Usamos isso para personalizar os indicadores que fazem mais sentido para voce.',
    segmentCards: {
      construtora: 'Construtora / Incorporadora',
      agencia: 'Agencia de marketing',
      franquia: 'Franquia',
      outro: 'Outro',
    },
    segmentCardsDesc: {
      construtora: 'Acompanhe leads, lancamentos e vendas de imoveis.',
      agencia: 'Gerencie clientes, campanhas e resultados em um lugar.',
      franquia: 'Veja o desempenho de todas as unidades juntas.',
      outro: 'Monte seus indicadores do jeito que o seu negocio funciona.',
    },
    sourcesConnectTitle: 'Conecte suas fontes de dados',
    sourcesConnectSubtitle:
      'Pode conectar mais de uma ao mesmo tempo. Uma fonte ja e suficiente para ver seus primeiros indicadores em ate 24 horas.',
    sourcesConnectNote:
      'Prefere pular? Tudo bem. Voce conecta depois em Fontes. So lembra que sem fonte nao tem dado.',
    sourceInstagram: 'Instagram Business',
    sourceInstagramDesc: 'Alcance, seguidores, engajamento e publicacoes.',
    sourceMetaAds: 'Meta Ads',
    sourceMetaAdsDesc: 'Campanhas, gasto, impressoes e cliques.',
    sourceGoogleDrive: 'Google Drive / Planilhas',
    sourceGoogleDriveDesc: 'Vendas, metas e qualquer dado que voce ja registra em planilha.',
    sourceStatusConnecting: 'Conectando...',
    sourceStatusConnected: 'Conectada',
    sourceStatusError: 'Problema na conexao',
    sourceStatusPending: 'Aguardando autorizacao',
    sourceConnectCta: 'Conectar',
    sourceRetryCta: 'Tentar de novo',
    sourceConnectErrorMsg:
      'Nao conseguimos abrir a autorizacao. Verifique sua conexao e tente de novo.',
    collectingTitle: 'Seus dados chegam em breve',
    collectingBody:
      'Ja iniciamos a primeira coleta das suas fontes. Em ate 24 horas seus indicadores aparecem no Espelho do Negocio. Voce recebe um aviso assim que estiver pronto.',
    collectingCta: 'Ir para o Espelho do Negocio',
    continueToSources: 'Continuar',
    backButton: 'Voltar',
    skipSources: 'Pular por agora',

    // Novos — tela fiel ao prototipo (F3)
    stepEyebrow1: 'Passo 1 de 3',
    stepEyebrow2: 'Passo 2 de 3',
    stepEyebrow3: 'Passo 3 de 3',
    stepLabel1: 'Criar conta',
    stepLabel2: 'Conectar fontes',
    stepLabel3: 'Tudo pronto',

    accountTitle: 'Bem-vindo ao CROSS.',
    accountSubtitle:
      'O CROSS vai coletar os dados do seu negocio e transformar em resumos claros, toda semana. Vamos criar a sua conta para comecar.',
    nameLabel: 'Seu nome',
    namePlaceholder: 'Ex.: Ana Lima',
    emailLabel: 'E-mail',
    emailPlaceholder: 'seu@email.com',
    passwordLabel: 'Senha',
    passwordPlaceholder: 'Minimo 8 caracteres',

    sourcesSecurityNote:
      'A conexao abre uma janela segura do Instagram, Meta ou Google. Voce aprova o acesso e volta aqui automaticamente. O CROSS nunca publica nada em seu nome.',

    successEyebrow: 'Passo 3 de 3',
    successTitle: 'Tudo certo. O CROSS esta trabalhando.',
    successSubtitle:
      'A primeira coleta de dados pode levar algumas horas. Veja abaixo o que acontece nos proximos dias.',

    timelineItem1Label: 'Conta criada e fontes conectadas',
    timelineItem1Meta: 'Feito agora. O CROSS ja tem o que precisa para comecar.',
    timelineItem2Label: 'Primeira coleta visivel no painel',
    timelineItem2Meta: 'Ate D+3 — o CROSS busca os seus dados e organiza tudo no painel.',
    timelineItem3Label: 'Primeiro resumo com analise',
    timelineItem3Meta:
      'Ate D+7 — o CROSS entrega o primeiro resumo do seu negocio com o que esta funcionando e o que merece atencao.',

    ctaDashboard: 'Ir para o painel',

    sourceInstagramIcon: 'Foto e alcance',
    sourceMetaAdsIcon: 'Anuncios e resultado',
    sourceGoogleDriveIcon: 'Planilhas e vendas',
  },
  dashboard: {
    heroTitle: 'Seu espelho de hoje',
    heroSubtitle: 'Indicadores essenciais do seu negocio, atualizados pela ultima coleta.',
    connectSource: 'Conectar fonte',
    goToSettings: 'Ir para ajustes',
    empty: {
      title: 'Conectando seus dados.',
      description:
        'Os primeiros numeros aparecem em poucas horas — o tempo das fontes processarem a primeira coleta. Se ainda nao conectou nenhuma fonte, comece agora para acelerar esse prazo.',
      cta: 'Conectar fontes',
    },
    loading: 'Carregando indicadores...',
    error: 'Nao foi possivel carregar os indicadores agora.',
    kpis: {
      reach: 'Alcance total',
      spend: 'Investido',
      leads: 'Leads',
      engagement: 'Engajamento',
      conversion: 'Conversao',
      placeholder: 'Aguardando coleta',
    },
  },
  settings: {
    title: 'Ajustes da conta',
    subtitle: 'Sua conta, seu espaco e o que voce pode mudar.',
    /* page header */
    pageEyebrow: 'Conta e preferencias',
    pageTitle: 'Configuracoes',
    pageSubtitle: 'Gerencie sua conta, seu negocio e as preferencias do CROSS Flux.',
    /* topbar proativa */
    topbarProactive: 'Ajustes da sua conta e do seu negocio.',
    /* bloco conta */
    accountSectionTitle: 'Sua conta',
    accountSectionKicker: 'Conta',
    nameLabel: 'Nome',
    namePlaceholder: 'Seu nome',
    emailLabel: 'E-mail',
    passwordLabel: 'Senha',
    passwordMasked: '••••••••••••',
    changePassword: 'Alterar senha',
    changePasswordUnavailable: 'Alterar senha — em breve.',
    logoutLabel: 'Encerrar sessao',
    logoutHint: 'Voce precisara entrar novamente.',
    /* bloco negocio */
    businessSectionTitle: 'Meu negocio',
    businessSectionKicker: 'Meu negocio',
    businessNameLabel: 'Nome do negocio',
    businessNamePlaceholder: 'Nome do seu negocio',
    businessUnitsLabel: 'Unidades',
    unitsPlaceholder: 'Selecione o numero de unidades',
    businessTypeLabel: 'Tipo de negocio',
    businessTypeFood: 'Alimentacao — rede de unidades fisicas',
    businessTypeFoodDelivery: 'Alimentacao — delivery',
    businessTypeRetail: 'Varejo fisico',
    businessTypeServices: 'Servicos',
    businessTypeOther: 'Outro',
    /* bloco preferencias */
    prefSectionTitle: 'Preferencias',
    prefSectionKicker: 'Experiencia',
    langLabel: 'Idioma',
    langPtBR: 'Portugues',
    langEn: 'English',
    langEs: 'Espanol',
    notifLabel: 'Notificacoes por e-mail',
    notifHint: 'O CROSS Flux avisa quando algo muda nos seus dados.',
    freqLabel: 'Frequencia dos resumos',
    freqDaily: 'Diario',
    freqWeekly: 'Semanal',
    freqBiweekly: 'Quinzenal',
    freqMonthly: 'Mensal',
    /* salvar */
    saveButton: 'Salvar alteracoes',
    saveUnavailable: 'Salvo — em breve.',
    /* em breve */
    soonBadge: 'Em breve',
    soonIntegTitle: 'Integracoes adicionais',
    soonIntegDesc:
      'Conecte Google Ads, TikTok e sistemas de pedidos diretamente aqui. Disponivel nos proximos ciclos do CROSS.',
    soonTeamTitle: 'Equipe e permissoes',
    soonTeamDesc:
      'Convide membros da equipe e defina quem pode ver o que. Gerentes de unidade com acesso separado por loja.',
    /* erros */
    errorSaveTitle: 'Nao foi possivel salvar',
    errorSaveDesc:
      'Verifique sua conexao e tente de novo. Suas alteracoes foram mantidas no formulario.',
    errorRetry: 'Tentar de novo',
    /* legado F1/F2 — mantidos para nao quebrar chamadas existentes */
    workspaceSectionTitle: 'Seu espaco de trabalho',
    soonSectionTitle: 'Em breve',
    roleLabel: 'Seu papel',
    mfaLabel: 'Verificacao em 2 etapas',
    mfaEnabled: 'Ativada',
    mfaDisabled: 'Desativada',
    workspaceNameLabel: 'Nome do espaco',
    workspaceLevelLabel: 'Tipo de espaco',
    planLabel: 'Plano',
    planDetailsLink: 'ver detalhes em Assinatura',
    soonBody:
      'Mudar senha, convidar usuarios, trocar email e gerenciar verificacao em 2 etapas chegam em breve. Por enquanto, fale com a equipe se precisar mudar algo aqui.',
    role: {
      owner: 'Dono',
      admin: 'Administrador',
      editor: 'Editor',
      member: 'Membro',
      viewer: 'Leitor',
      apiConsumer: 'Integracao',
    },
    workspaceLevel: {
      root: 'Espaco principal',
      intermediate: 'Espaco intermediario',
      leaf: 'Unidade operacional',
    },
    logout: 'Sair da conta',
    tenantId: 'ID do espaco',
    plan: 'Plano',
    usage: 'Uso atual',
    usagePlaceholder: 'Coleta ainda nao iniciada',
    planPlaceholder: 'Starter',
  },
  errors: {
    required: 'Campo obrigatorio.',
    invalidEmail: 'E-mail invalido.',
    passwordTooShort: 'Senha deve ter pelo menos 8 caracteres.',
    network: 'Erro de rede. Verifique sua conexao.',
    unauthorized: 'Sessao expirada. Entre novamente.',
  },
  mfa: {
    setup: {
      title: 'Ative a verificacao em duas etapas',
      description:
        'Sua conta protege o negocio de alguem. Vamos adicionar uma segunda camada de seguranca em menos de um minuto — use um app como Google Authenticator, 1Password ou Authy.',
      stepScan: '1. Escaneie o QR code com seu app autenticador',
      stepCode: '2. Informe o codigo de 6 digitos exibido no app',
      codeLabel: 'Codigo de 6 digitos',
      codePlaceholder: '000000',
      confirm: 'Confirmar e ativar',
      submitting: 'Ativando...',
      manualKey: 'Ou insira manualmente esta chave no seu app',
      copyKey: 'Copiar chave',
      copied: 'Copiado',
      recoveryTitle: 'Guarde seus codigos de recuperacao',
      recoverySubtitle:
        'Voce vai precisar deles se perder o acesso ao app autenticador. Cada codigo funciona uma unica vez. Salve em um local seguro antes de sair desta tela.',
      copyRecovery: 'Copiar codigos',
      done: 'Ja salvei meus codigos',
      invalidCode: 'Este codigo nao conferiu. Confira no app e tente de novo.',
      loadFailed: 'Nao conseguimos preparar sua configuracao de MFA agora. Volte em instantes.',
    },
    challenge: {
      title: 'Confirme que e voce',
      description: 'Informe o codigo de 6 digitos exibido no seu app autenticador para continuar.',
      codeLabel: 'Codigo de 6 digitos',
      codePlaceholder: '000000',
      verify: 'Verificar',
      submitting: 'Verificando...',
      useRecovery: 'Usar codigo de recuperacao',
      recoveryLabel: 'Codigo de recuperacao',
      recoveryHint: 'Informe um dos codigos que voce guardou quando ativou o MFA.',
      backToCode: 'Voltar ao codigo do app',
      invalid: 'Codigo invalido. Confira e tente de novo.',
    },
    gate: {
      graceBanner:
        'Sua verificacao em duas etapas precisa ser ativada ate {date}. Recomendamos fazer isso agora.',
      graceCta: 'Ativar agora',
      dismissBanner: 'Lembrar depois',
      immediateTitle: 'Seguranca obrigatoria antes de continuar',
      immediateDescription:
        'Voce administra um espaco que tem outras unidades vinculadas. Por isso o CROSS Flux exige verificacao em duas etapas antes de liberar o painel.',
      immediateCta: 'Ativar agora',
    },
  },
  mirror: {
    title: 'Espelho do negocio',
    subtitle: 'A leitura viva do seu negocio, sem planilha no caminho.',
    heroFallback: 'Ainda estamos montando o espelho do seu negocio.',
    sourcesTitle: 'Fontes conectadas',
    alertsTitle: 'Atencoes agora',
    alertsEmpty: 'Nenhum ponto de atencao no momento.',
    openRadar: 'Abrir Radar de risco',
    ctaChat: 'Perguntar ao CROSS Flux sobre esses numeros',
    loading: 'Lendo seus numeros...',
    error: 'Nao conseguimos ler seu espelho agora. Tente novamente em instantes.',
    retryLabel: 'Tentar novamente',
    coldStartTitle: 'Coletando seus primeiros dados',
    coldStartBody:
      'Seus indicadores aparecem aqui em 24 a 72 horas — o tempo das suas fontes processarem a primeira coleta. Se ainda nao conectou nenhuma fonte, comece agora para acelerar esse prazo.',
    empty:
      'Conecte sua primeira fonte para ver seu espelho preenchido. Se ja conectou, a primeira coleta leva algumas horas — volte em breve para ver o retrato inicial.',
    emptyCta: 'Conectar fontes',
  },
  fourPs: {
    title: 'Funil de marketing',
    subtitle: 'Como seus resultados evoluem do alcance ate a venda, camada por camada.',
    tabs: {
      visibilidade: 'Visibilidade',
      engajamento: 'Engajamento',
      trafego: 'Trafego',
      vendas: 'Vendas',
    },
    period: {
      label: 'Periodo',
      d7: 'Ultimos 7 dias',
      d30: 'Ultimos 30 dias',
      d90: 'Ultimos 90 dias',
      d365: 'Ultimos 12 meses',
      specificMonth: 'Mes especifico',
    },
    monthFilter: {
      monthLabel: 'Mes',
      yearLabel: 'Ano',
      apply: 'Aplicar',
      months: {
        m1: 'Janeiro',
        m2: 'Fevereiro',
        m3: 'Marco',
        m4: 'Abril',
        m5: 'Maio',
        m6: 'Junho',
        m7: 'Julho',
        m8: 'Agosto',
        m9: 'Setembro',
        m10: 'Outubro',
        m11: 'Novembro',
        m12: 'Dezembro',
      },
    },
    source: {
      label: 'Fonte',
      all: 'Todas as fontes',
    },
    drilldownTitle: 'Detalhes do indicador',
    closeDrilldown: 'Fechar detalhes',
    empty: 'Ainda nao ha dados desta camada no periodo escolhido.',
    emptyMonth: 'Nenhuma venda registrada neste mes.',
    emptyMonthVisibilidade:
      'Nenhum dado de alcance neste periodo. Verifique se o Instagram esta conectado em Fontes.',
    emptyMonthEngajamento:
      'Nenhuma interacao registrada neste periodo. Publique conteudo e aguarde a proxima coleta.',
    emptyMonthTrafego:
      'Nenhum acesso registrado neste periodo. Conecte o Meta Ads ou verifique sua planilha de trafego em Fontes.',
    emptyMonthVendas:
      'Nenhuma venda registrada neste periodo. Adicione sua planilha de vendas em Fontes para ver os resultados aqui.',
    coldStartTitle: 'Coletando seus primeiros dados',
    coldStart:
      'O funil toma forma conforme os dados historicos das suas fontes sao processados. Instagram e Meta Ads trazem ate 2 anos de historico automaticamente — a primeira leitura completa aparece aqui em 24 a 72 horas. Se ainda nao conectou nenhuma fonte, comece agora.',
    coldStartCta: 'Conectar fontes',
    loading: 'Carregando indicadores...',
    error: 'Nao foi possivel carregar o funil agora. Tente de novo em instantes.',
    retryLabel: 'Tentar novamente',
    layerDesc: {
      visibilidade: 'Quantas pessoas o seu negocio alcancou.',
      engajamento: 'Quantas pessoas interagiram com o seu conteudo.',
      trafego: 'Quantas pessoas clicaram e vieram ao seu espaco.',
      vendas: 'Quantas vendas e quanto faturamento voce gerou.',
    },
  },
  panel: {
    title: 'Painel',
    /* Strings do page header do Painel (migradas de PAGE_HEADER_STRINGS) */
    pageEyebrow: 'Painel · visao completa',
    pageTitlePre: 'Seu marketing',
    pageTitleEm: 'em numeros.',
    pageSub: 'Seus resultados comerciais e digitais em um lugar so.',
    pageMetaLoading: 'Carregando indicadores...',
    pageFunnelHeadline: 'Visao completa do seu marketing',
    pageMetaPeriodLabel: 'Periodo de',
    pageMetaSources: 'Fontes: Instagram · Meta Ads · Drive',
    /* Strings do hero bento (migradas de HERO_STRINGS) */
    heroFaturamentoTag: 'Faturamento do periodo',
    heroFaturamentoLabel: 'receita registrada no periodo',
    heroFaturamentoNoData: 'Sem dado — conecte Planilhas do Drive para ver',
    heroFaturamentoSrc: 'via Planilhas do Drive',
    heroFaturamentoVerOrigem: 'ver origem',
    heroFaturamentoSemComp: 'sem comparativo ainda',
    heroProdutoLabel: 'Produtos vendidos',
    heroProdutoSub: 'no periodo',
    heroProdutoNoData: 'conecte Drive para ver',
    heroAlcanceLabel: 'Alcance total',
    heroAlcanceSub: 'pessoas unicas · Instagram',
    heroAlcanceNoData: 'conecte Instagram para ver',
    heroInsightEyebrow: 'Resumo do periodo',
    heroInsightFallback: 'Seus indicadores do periodo estao aqui.',
    heroInsightFallbackBold: 'Explore as abas',
    heroInsightFallbackSuffix: 'para entender cada camada do seu marketing.',
    heroInsightCta: 'Perguntar ao CROSS Flux',
    heroNoData: 'sem dado',
    heroLinkLabel: 'ver origem',
    heroSection: 'Painel de resultados',
    heroChatChip: 'Conversar com o CROSS Flux',
    heroVsAnterior: 'vs. mes anterior',
    /* Strings do modal de drilldown (migradas de MODAL_STRINGS) */
    modalSourceLabel: 'Fonte',
    modalAccountLabel: 'Conta',
    modalPeriodLabel: 'Periodo',
    modalCollectedLabel: 'Coletado',
    modalOriginLabel: 'Origem do dado',
    modalCtaLabel: 'Perguntar ao CROSS Flux sobre isso',
    /* Labels de fonte (migradas de SOURCE_LABELS) */
    sourceIg: 'Instagram',
    sourceAds: 'Meta Ads',
    sourceDrive: 'Planilhas do Drive',
    sourceOther: 'Fonte de dados',
    subtitle: 'Seus resultados comerciais e digitais em um lugar so.',
    bridgeLabel: 'Ponte CROSS — onde o digital encontra o comercial',
    tabComercial: 'Comercial',
    tabDigital: 'Digital',
    secaoResultado: 'Resultado',
    secaoPreco: 'Preco',
    secaoPraca: 'Praca',
    secaoProduto: 'Produto',
    secaoMidiaPaga: 'Midia paga',
    secaoOrganico: 'Organico',
    produtoEmBreve: 'Detalhe por sabor em breve',
    produtoEmBreveDesc:
      'Estamos preparando o detalhamento de vendas por produto. Aparece aqui assim que estiver disponivel.',
    emptyComercial:
      'Nenhum dado comercial neste periodo. Adicione sua planilha de vendas em Fontes.',
    emptyDigital:
      'Nenhum dado digital neste periodo. Verifique se o Instagram ou Meta Ads estao conectados em Fontes.',
    coldStartTitle: 'Coletando seus primeiros dados',
    coldStart:
      'Os indicadores aparecem aqui em 24 a 72 horas — o tempo das suas fontes processarem a primeira coleta. Se ainda nao conectou nenhuma fonte, comece agora.',
    coldStartCta: 'Conectar fontes',
    loading: 'Carregando painel...',
    error: 'Nao foi possivel carregar o painel agora. Tente de novo em instantes.',
    retryLabel: 'Tentar novamente',
    drilldownTitle: 'Detalhes do indicador',
    closeDrilldown: 'Fechar detalhes',
    period: {
      label: 'Periodo',
    },
    monthFilter: {
      monthLabel: 'Mes',
      yearLabel: 'Ano',
      apply: 'Aplicar',
    },
  },
  chat: {
    title: 'Conversar com o CROSS',
    subtitle: 'Pergunte sobre seus numeros — o CROSS cita de onde tirou cada informacao.',
    topbarTitle: 'Conversar com o CROSS Flux',
    topbarProactive: 'Pergunte sobre seus numeros do jeito que voce fala.',
    topbarFreshness: 'Atualizado hoje',
    typingStatus: 'Analisando seus dados...',
    errorHeader: 'Nao consegui processar sua pergunta agora.',
    errorBody: 'Problema temporario. Seus dados estao intactos.',
    retryAriaLabel: 'Tentar enviar a pergunta novamente',
    sendAriaLabel: 'Enviar mensagem',
    inputAriaLabel: 'Mensagem para o CROSS Flux',
    senderCross: 'CROSS',
    senderYou: 'Voce',
    sessionsTitle: 'Conversas',
    newSession: 'Nova conversa',
    emptySessions: 'Voce ainda nao tem conversas.',
    emptyMessages: 'Pronto pra conversar. Escolha uma sugestao abaixo ou pergunte o que quiser.',
    suggestion1: 'Como foi minha semana?',
    suggestion2: 'Qual canal trouxe mais alcance?',
    suggestion3: 'Estou gastando bem nas campanhas?',
    inputLabel: 'Sua pergunta',
    inputPlaceholder: 'Pergunte sobre seus numeros...',
    send: 'Enviar',
    sending: 'CROSS esta pensando...',
    assistantLabel: 'Resposta do CROSS',
    userLabel: 'Voce',
    sourcesLabel: 'Fontes citadas',
    sourcesCount: 'Fontes citadas ({count})',
    sourceMore: '+ {count} mais',
    error: 'Nao foi possivel obter a resposta agora.',
    errorRetry: 'Tentar novamente',
    streamingFallback: 'Resposta completa carregada.',
    sourceTypeLabel: {
      google_drive: 'Google Drive',
      instagram: 'Instagram',
      meta_ads: 'Meta Ads',
      google_analytics: 'Google Analytics',
      whatsapp: 'WhatsApp',
      manual: 'Entrada manual',
      pdv: 'Ponto de venda',
      crm: 'CRM',
      outro: 'Fonte de dados',
    },
    fallback: {
      no_data: {
        title: 'Ainda nao tenho dados desse periodo no seu negocio.',
        body: 'Assim que as planilhas chegarem ao Google Drive ou a proxima coleta rodar, consigo responder isso com numeros reais.',
        cta: 'Ver fontes conectadas',
      },
      out_of_scope: {
        title: 'Isso esta fora do que consigo ver aqui.',
        body: 'O CROSS trabalha com os dados das fontes conectadas ao seu negocio: Instagram, Meta Ads, planilhas do Drive e CRM. Sobre isso consigo responder com numeros reais.',
        cta: 'Quer tentar uma pergunta sobre vendas, anuncios ou Instagram?',
      },
      ambiguous: {
        title:
          'Consegui encontrar varios dados, mas preciso entender melhor o que voce quer saber para dar uma resposta com numero real.',
        suggestionSales: '"Como estao as vendas em maio?"',
        suggestionInstagram: '"Meu Instagram cresceu este mes?"',
        suggestionAds: '"O anuncio desta semana esta trazendo retorno?"',
      },
      connectSources: 'Ver fontes conectadas',
    },
    sourceTooltip: {
      source: 'Fonte',
      period: 'Periodo',
      account: 'Conta',
    },
    viewSource: 'Ver fonte: {label}',
  },
  sources: {
    title: 'Fontes conectadas',
    subtitle: 'Conecte suas contas para o CROSS Flux ler seu negocio.',
    status: {
      connected: 'Conectada',
      disconnected: 'Desconectada',
      error: 'Com problema',
    },
    connect: 'Conectar',
    disconnect: 'Desconectar',
    lastRun: 'Ultima coleta',
    nextRun: 'Proxima coleta',
    neverRan: 'Ainda nao coletou',
    confirmDisconnectTitle: 'Tem certeza que quer desconectar?',
    confirmDisconnectBody: 'Voce para de receber dados desta fonte ate reconectar.',
    confirmDisconnectOk: 'Desconectar agora',
    confirmDisconnectCancel: 'Manter conectada',
    loading: 'Carregando fontes...',
    error: 'Nao foi possivel carregar suas fontes. Tente novamente.',
    connectError: 'Nao conseguimos iniciar a conexao. Tente novamente em instantes.',
    selectFolder: 'Selecionar pasta',
    changeFolder: 'Trocar pasta',
    folderSelected: 'Pasta selecionada',
  },
  fontes: {
    pageEyebrow: 'Conexoes ativas',
    pageTitlePart1: 'Suas',
    pageTitleEm: 'fontes',
    pageTitlePart2: 'de dados.',
    pageSub: 'E daqui que o CROSS Flux busca os numeros que aparecem no seu painel.',
    pageMetaConnected: '{count} fontes conectadas',
    pageMetaLastSync: 'Ultima coleta hoje',
    chartKicker: 'Coleta do periodo',
    chartHeadline: 'Volume de registros por fonte',
    chartGuide:
      'Quantidade total de pontos de dado coletados por cada fonte neste periodo. Quanto maior, mais base o CROSS Flux tem para calcular seus KPIs.',
    chartAriaLabel: 'Grafico de volume de registros por fonte no periodo.',
    status: {
      connected: 'Conectado',
      warn: 'Atencao',
      disconnected: 'Desconectado',
      dataGap: 'Intermitente',
    },
    collectsLabel: 'O que o CROSS Flux coleta aqui',
    feeds: {
      ig: {
        reach: 'Alcance e impressoes dos posts',
        engagement: 'Engajamento (curtidas, comentarios, salvamentos)',
        followers: 'Crescimento de seguidores',
        profileVisits: 'Visitas ao perfil',
      },
      ads: {
        reach: 'Alcance e impressoes pagas',
        clicks: 'Cliques, CPC, CTR e CPM por campanha',
        spend: 'Investimento total em anuncios',
        frequency: 'Frequencia de exibicao',
      },
      drive: {
        sales: 'Vendas diarias das unidades',
        items: 'Volume de itens vendidos',
        revenue: 'Faturamento bruto do periodo',
        avgTicket: 'Ticket medio calculado',
      },
    },
    banner: {
      noNewData:
        'Sem dados novos neste periodo. O CROSS Flux nao encontrou planilhas atualizadas desde {lastSync}.',
      expired: 'A conexao com o {source} expirou. O CROSS Flux parou de coletar dados desta conta.',
      dataGap: 'Dados incompletos em alguns dias. A plataforma nao retornou dados nessas datas.',
      dataGapCta: 'Entender por que',
    },
    kpi: {
      reach: 'Alcance',
      impressions: 'Impressoes',
      unavailable: 'Dado indisponivel neste periodo',
      noData: 'sem dado',
    },
    actions: {
      verifyFolder: 'Verificar pasta',
    },
    reconnect: 'Reconectar {source}',
    reconnectPreventive: 'Reconectar {source} (preventivo)',
    reconnectPreventiveShort: 'Reconectar (preventivo)',
    addSource: 'Adicionar nova fonte de dados',
    addTitle: 'Adicionar fonte',
    addDesc:
      'Conecte mais uma origem de dados e o CROSS Flux passa a inclui-la nos seus numeros automaticamente.',
    addCta: 'Ver fontes disponiveis',
  },
  drivePicker: {
    title: 'Escolha a pasta da sua operacao',
    subtitle:
      'Selecione a pasta que contem as planilhas que voce quer que o CROSS Flux analise. So precisa fazer uma vez.',
    tabMine: 'Meu Drive',
    tabShared: 'Compartilhados comigo',
    selectThisFolder: 'Selecionar esta pasta',
    changeFolder: 'Trocar pasta',
    folderSelectedLabel: 'Pasta selecionada: {nome}',
    noFolders: 'Nenhuma pasta encontrada',
    emptyShared: 'Nenhuma pasta compartilhada encontrada.',
    loading: 'Carregando...',
    back: 'Voltar',
    confirmSelection: 'Confirmar selecao',
    loadMore: 'Carregar mais pastas',
    openDrive: 'Abrir Google Drive em nova aba',
    errorNetwork: 'Nao conseguimos carregar as pastas. Verifique sua conexao e tente novamente.',
    errorAuth:
      'Sua autorizacao com o Google expirou. Desconecte e reconecte o Google Drive para continuar.',
    errorFolderDeleted: 'A pasta selecionada nao existe mais no seu Drive. Escolha outra pasta.',
    errorGeneric: 'Algo deu errado ao carregar as pastas. Tente novamente.',
    confirmError: 'Nao conseguimos salvar sua escolha. Tente novamente.',
  },
  billing: {
    title: 'Assinatura e uso',
    subtitle: 'Seu plano, seus limites e suas compras.',
    currentPlan: 'Plano atual',
    nextBilling: 'Proxima cobranca em',
    cycle: 'Ciclo',
    upgrade: 'Fazer upgrade de plano',
    buyCredit: 'Comprar credito adicional',
    usageTitle: 'Quanto voce ja usou neste mes',
    usageEmpty: 'Voce ainda nao consumiu limites neste plano.',
    historyTitle: 'Historico de pagamentos',
    historyEmpty: 'Nenhum pagamento registrado ate agora.',
    creditDialogTitle: 'Quanto credito voce quer comprar?',
    creditDialogBody: 'O valor fica disponivel em seguida e nao expira.',
    creditDialogConfirm: 'Comprar credito',
    creditDialogCancel: 'Cancelar',
    loading: 'Carregando assinatura...',
    error: 'Nao foi possivel carregar sua assinatura agora.',
    limitOf: 'de',
    upgradeUnavailable: 'Em breve. Por enquanto, fale com a equipe para mudar de plano.',
    nextBillingNone: 'Nao agendada',
    /* Chaves adicionadas para a tela Plano (F3) */
    planStatusActive: 'Ativo',
    featuresTitle: 'O que esta incluido',
    nextBillingLabel: 'Proximo vencimento',
    paymentMethodLabel: 'Metodo',
    priceLabel: 'Valor do plano',
    priceCycle: 'por mes · cobrado mensalmente',
    priceDeferredNote: 'cobranca configurada em breve',
    planCancelNote: 'Cancele quando quiser. Sem multa, sem fidelidade.',
    viewPlans: 'Ver planos',
    viewPlansAriaLabel: 'Ver planos disponiveis (em breve)',
    viewPlansDeferredMsg: 'Selecao de planos disponivel em breve. Fale com a equipe.',
    pageEyebrow: 'Assinatura ativa',
    pageTitle: 'Seu plano CROSS',
    pageTitleEm: 'plano',
    pageSub: 'Ciclo mensal',
    usageCardTitle: 'Uso do plano',
    billingCardTitle: 'Proxima cobranca',
    billingDeferredNote:
      'Cobranca real sera configurada em F5. Por enquanto os dados de plano sao de referencia.',
    supportCardTitle: 'Precisa de ajuda?',
    supportCardText:
      'O CROSS Flux esta aqui. Se tiver qualquer duvida sobre o seu plano, cobranca ou conta, use o chat.',
    supportCardCta: 'Falar com o CROSS Flux',
    statesDemoTitle: 'Estados do sistema — referencia de design',
    stateLoadingLabel: 'Estado: carregando',
    stateEmptyLabel: 'Estado: vazio',
    stateErrorLabel: 'Estado: erro de cobranca',
    emptyPaymentsMsg: 'Nenhum pagamento ainda',
    emptyPaymentsHint: 'Quando a primeira cobranca for processada, o historico aparece aqui.',
    errorPaymentTitle: 'Pagamento nao processado',
    errorPaymentDesc: 'Verifique o limite do cartao ou use outro metodo de pagamento.',
    errorPaymentCta: 'Atualizar cartao',
    dataGapNote: 'Dado intermitente — nunca exibido como 0.',
    usageLabelFontes: 'Fontes conectadas',
    usageLabelHistorico: 'Historico disponivel',
    usageLabelRelatorios: 'Relatorios gerados',
    usageNoteFontesLimit: 'Limite do plano atingido.',
    usageNoteHistoricoOk: 'Maximo do plano — incluido integralmente.',
    usageNoteRelatoriosOk: 'Sem limite no plano. Gere quantos precisar.',
    usageUnitFontes: 'fontes',
    usageUnitMeses: 'meses',
    usageUnitRelatorios: 'relatorios',
    billingNextSub: 'em 30 dias · debito automatico',
    billingDiscountLabel: 'Desconto (anual)',
    billingDiscountNone: '—',
    billingTotalLabel: 'Total',
    /* Features do plano — copias gerenciadas pelo Content-Designer */
    feature1Label: 'Ate 3 fontes conectadas',
    feature1Desc: 'Instagram, Meta Ads e Planilhas do Drive',
    feature2Label: 'Atualizacao diaria automatica',
    feature2Desc: 'A CROSS coleta dados toda manha, sem voce precisar fazer nada',
    feature3Label: 'Descobertas e alertas do CROSS Flux',
    feature3Desc: 'Analises em portugues, com sugestao de acao concreta',
    feature4Label: 'Chat com o CROSS Flux',
    feature4Desc: 'Pergunte sobre qualquer dado do seu negocio, a qualquer hora',
    feature5Label: 'Historico de 12 meses',
    feature5Desc: 'Veja como seu negocio evoluiu ao longo do ano',
    feature6Label: 'Relatorio narrativo mensal',
    feature6Desc: 'Um resumo em texto do mes, escrito para dono',
    sidebarAriaLabel: 'Uso e cobranca',
  },
  radar: {
    title: 'Radar de risco',
    subtitle: 'O que esta tirando o sono do seu negocio agora.',
    scoreLabel: 'Saude do seu marketing',
    alertsTitle: 'Pontos de atencao',
    severity: {
      critical: 'Critico',
      warning: 'Atencao',
      ok: 'Sob controle',
    },
    explainWithAi: 'Explicar com o CROSS Flux',
    explainWithCross: 'Explicar com o CROSS Flux',
    diagnosisLabel: 'O que eu vi',
    sourcesLabel: 'Baseado em',
    empty: 'Nenhum risco detectado no momento. Siga em frente.',
    coldStart:
      'O radar de risco precisa de pelo menos uma janela de coleta para calcular o score. A primeira janela leva cerca de 24 horas apos conectar suas fontes. Se ainda nao conectou nenhuma, comece por aqui.',
    coldStartCta: 'Conectar fontes',
    loading: 'Varrendo o radar...',
    error: 'Nao foi possivel carregar o radar agora.',
    pageEyebrow: 'Radar de risco',
    pageTitle: 'Saude do marketing',
    heroTitle: 'Saude do marketing',
    heroPeriodNone: 'Periodo indisponivel',
    heroScoreBom: 'BOM',
    heroScoreAtencao: 'ATENCAO',
    heroScoreCritico: 'CRITICO',
    heroScoreNull: 'Aguardando coleta',
    heroTrendNull: 'Acompanhamento de tendencia comeca nas proximas semanas',
    indicadoresTitle: 'Indicadores-chave do periodo',
    indicadoresNormal: 'Saudaveis',
    indicadoresVerificar: 'A verificar',
    indicadoresAtencao: 'Atencao imediata',
    indicadoresNull: 'Indicadores aparecem quando houver coleta completa',
    donutNull: 'Indicadores aparecem quando houver coleta',
    footerIndicadores: '{total} indicadores',
    alertsSection: 'O que pede acao agora',
    alertsSectionSub: 'Alertas e pendencias acionaveis',
    alertsSectionGuide: 'Clique em qualquer item para ver a origem do numero.',
    alertEmptyFilter: 'Nenhum alerta nesta categoria.',
    alertSevDanger: 'Atencao',
    alertSevWarning: 'A verificar',
    alertSevOk: 'Saudavel',
    alertRecommendationPrefix: 'Acao:',
    filterAll: 'Todos',
    filterDanger: 'Atencao',
    filterWarning: 'A verificar',
    filterOk: 'Saudavel',
    dimensionsKicker: 'Saude do marketing',
    dimensionsHeadline: 'Seu negocio em {n} dimensoes',
    dimensionsGuide: 'Quanto mais cheia a teia, mais redondo esta o seu marketing.',
    dimensionsNull: 'O grafico de dimensoes aparece com mais coletas. Voltando em breve.',
    dimensionsFooter: 'Clique nos pontos para ver o que esta por tras de cada dimensao.',
    findingsKicker: '{n} sinais que merecem seu olhar',
    findingsHeadline: 'O que o CROSS encontrou',
    findingsEmpty: 'Nenhum achado no momento.',
    trendKicker: 'Tendencia — historico semanal',
    trendHeadline: 'Acompanhamento do score',
    trendNullMessage:
      'O acompanhamento de tendencia comeca a aparecer nas proximas semanas, conforme as coletas se acumulam.',
    trendNullHint:
      'A CROSS precisa de pelo menos duas semanas de dados para calcular a linha de tendencia.',
    trendInfoHint: 'O ponto vermelho e o resultado mais recente.',
    channelsKicker: 'Distribuicao por canal',
    channelsHeadline: 'De onde vem seu alcance',
    channelsGuide: 'Total de pessoas alcancadas no periodo.',
    channelsNull: 'Dados de alcance por canal chegam com a proxima coleta.',
    channelsSingleSource: 'Apenas {name} conectado ate agora.',
    indicatorsGridKicker: 'Todos os indicadores — com origem de dado',
    indicatorsGridHeadline: 'O que precisa do seu olhar — e o que esta bem',
    indicatorsGridGuide:
      'Clique em qualquer linha para ver a origem do numero e a acao recomendada.',
    indicatorsGroupAtencao: 'Atencao',
    indicatorsGroupVerificar: 'A verificar',
    indicatorsGroupSaudavel: 'Saudaveis',
    indicatorsEmpty: 'Nenhum indicador disponivel ainda.',
    indicatorOpenChat: 'Perguntar ao CROSS Flux',
    fabLabel: 'Perguntar ao CROSS Flux',
    scoreTrendNull: 'sem historico ainda',
    /* Donut SVG — legenda central */
    donutCenterLabel: 'indicadores',
    /* aria-labels compostos — templates com {n} */
    donutAriaFull:
      '{total} indicadores: {normal} normais, {verificar} a verificar, {atencao} com atencao',
    radarSubIndicators: '· {total} indicadores',
    ariaAtencaoImediata: '{n} indicadores com atencao imediata',
    ariaAVerificar: '{n} indicadores a verificar',
    ariaSaudaveis: '{n} indicadores saudaveis',
    ariaPeriodo: 'Periodo: {label}',
    ariaScoreGeral: 'Saude geral do marketing: {score} de 100',
  },
  insights: {
    title: 'Descobertas do CROSS Flux',
    subtitle: 'O que o CROSS Flux encontrou nos seus dados que merece sua atencao.',
    filter: 'Categoria',
    filterAll: 'Todas',
    empty:
      'Assim que o CROSS Flux tiver algo surpreendente, voce ve aqui. Normalmente as primeiras descobertas aparecem 2 a 3 dias apos a primeira coleta — o tempo de acumular dados suficientes para o CROSS Flux encontrar padroes significativos. Se ainda nao conectou nenhuma fonte, comece agora.',
    emptyCta: 'Conectar fontes',
    expand: 'Ver detalhes',
    collapse: 'Esconder detalhes',
    deepen: 'Aprofundar com o CROSS Flux',
    suggestedAction: 'Proxima acao sugerida',
    loading: 'Procurando padroes...',
    error: 'Nao foi possivel carregar insights agora.',
    refreshCta: 'Gerar insights agora',
    refreshing: 'CROSS Flux esta lendo seus dados...',
    refreshSuccess: 'Novos insights prontos.',
    refreshNoData:
      'Ainda nao ha dados suficientes para gerar insights. Conecte fontes e aguarde a proxima coleta.',
    refreshError: 'Nao consegui gerar agora. Tente novamente em alguns minutos.',
    refreshRateLimited: 'Voce ja pediu ha pouco. Espere alguns minutos e tente de novo.',
    pageEyebrow: 'Insights',
    pageTitle: 'O que o CROSS',
    pageTitleEm: 'encontrou pra voce.',
    pageSub: 'Seus dados de marketing — padroes, oportunidades e pontos de atencao.',
    pageMetaLabel: 'Fontes',
    pageMetaSources: 'Instagram · Meta Ads · Drive',
    funilLabel: 'Desempenho geral',
    funilAriaLabel: 'Funil de desempenho. Alcance, salvamentos, faturamento, engajamento e CPC.',
    funilEmptyFlag: 'Grafico aparece quando houver dados coletados nas fontes.',
    editorialKicker: 'Esta semana',
    editorialHeadline: 'O que o CROSS encontrou pra voce.',
    editorialGuide: 'Baseado nos dados das suas fontes conectadas.',
    editorialGuideReal:
      'Baseado em {reach} de pessoas alcancadas em maio · CPC monitorado · 22% do faturamento concentrado na sexta',
    sectionDiscoveries: 'Descobertas',
    sectionAttention: 'Merece atencao',
    kickerDiscovery: 'Descoberta',
    kickerAttention: 'Atencao',
    badgeNew: 'Novo',
    iconOrigin: 'Origem do dado',
    modalAccount: 'Conta',
    modalPeriod: 'Periodo',
    modalCollected: 'Coletado',
    modalCtaChat: 'Perguntar ao CROSS Flux sobre isso',
    modalCloseLabel: 'Fechar dialogo de origem do dado',
    btnChatCross: 'Conversar com o CROSS Flux sobre isso',
    btnMetrics: 'Ver metricas',
    numsFlag: 'Dados numericos disponiveis apos integracao do backend',
    sourceInstagram: 'Instagram',
    sourceMetaAds: 'Meta Ads',
    sourceDrive: 'Planilhas do Drive',
    sourceVia: 'via {source}',
    sourceOriginLabel: 'Origem: {source}',
    fabLabel: 'Perguntar ao CROSS Flux',
    insightAriaLabel: 'Insight: {title}',
    oppItemAriaLabel: 'Ver descoberta: {title}',
    editorialHeadlineSingle: '1 descoberta que o CROSS encontrou pra voce.',
    editorialHeadlinePlural: '{n} descobertas que o CROSS encontrou pra voce.',
  },
  dialog: {
    confirm: 'Confirmar',
    cancel: 'Cancelar',
    close: 'Fechar',
  },
  productMetrics: {
    title: 'Metricas de produto',
    subtitle: 'Painel interno — dados por tenant, atualizados em tempo real.',
    ttfvLabel: 'TTFV medio (dias)',
    ttfvDesc: 'Tempo entre signup_completed e first_kpi_viewed.',
    activationRateLabel: 'Taxa de ativacao',
    activationRateDesc: 'Tenants que completaram pelo menos uma coleta.',
    firstKpiViewedLabel: 'first_kpi_viewed',
    firstKpiViewedDesc: 'Numero de tenants que ja viram um KPI real.',
    tableHeaderTenant: 'Tenant',
    tableHeaderSegment: 'Segmento',
    tableHeaderSignup: 'Signup',
    tableHeaderFirstSource: 'Primeira fonte',
    tableHeaderFirstKpi: 'Primeiro KPI',
    tableHeaderTtfv: 'TTFV (dias)',
    tableHeaderActivated: 'Ativado',
    loading: 'Carregando metricas...',
    error: 'Nao foi possivel carregar as metricas agora. Tente novamente.',
    retryLabel: 'Tentar novamente',
    empty: 'Nenhum tenant registrado ainda.',
    activated: 'Sim',
    notActivated: 'Nao',
    ttfvMet: 'Dentro da meta',
    ttfvMissed: 'Fora da meta',
  },
  tenants: {
    switcher: {
      label: 'Espaco ativo',
      open: 'Trocar de espaco',
      current: 'Voce esta em',
      levelRoot: 'Matriz',
      levelIntermediate: 'Intermediario',
      levelLeaf: 'Unidade',
      roleOwner: 'Dono',
      roleAdmin: 'Admin',
      roleEditor: 'Editor',
      roleMember: 'Membro',
      roleViewer: 'Leitor',
      roleApiConsumer: 'API',
      switching: 'Trocando...',
      elsewhereBadge: 'Voce esta em outro espaco',
      emptyHint: 'Voce ainda nao pertence a outro espaco.',
      lostAccess: 'Voce nao tem mais acesso a este espaco. Levamos voce para o proximo disponivel.',
      switchFailed: 'Nao conseguimos trocar de espaco agora. Tente novamente em instantes.',
    },
  },
  digital: {
    pageEyebrow: 'Canais digitais',
    pageTitle: 'Canais Digitais',
    pageSub: 'Instagram e Meta Ads em um lugar so.',
    tabOverview: 'Visao geral',
    tabInstagram: 'Analisar Instagram',
    tabMetaAds: 'Meta Ads',
    tabCampaigns: 'Analise de campanhas',
    /* Visao geral */
    overviewTitle: 'Visao geral do digital',
    overviewSub: 'Instagram + Meta Ads consolidados.',
    /* Instagram */
    instagramTitle: 'Instagram',
    instagramSub: 'Alcance, engajamento e crescimento organico.',
    /* Meta Ads */
    metaAdsTitle: 'Meta Ads',
    metaAdsSub: 'Investimento, CTR, CPC e CPM das suas campanhas.',
    /* Estados */
    loading: 'Carregando indicadores digitais...',
    error: 'Nao foi possivel carregar os dados digitais agora. Tente de novo em instantes.',
    retryLabel: 'Tentar novamente',
    emptyNoSource: 'Fonte nao conectada.',
    emptyNoSourceDesc: 'Conecte esta fonte para ver os indicadores aqui.',
    emptyNoSourceCta: 'Conectar fontes',
    emptyNoPeriod: 'Sem dados neste periodo.',
    emptyNoPeriodDesc: 'Nao ha dados coletados para o periodo selecionado nesta fonte.',
    coldStartTitle: 'Coletando seus primeiros dados',
    coldStart:
      'Os indicadores digitais aparecem aqui em 24 a 72 horas apos a primeira coleta. Se ainda nao conectou nenhuma fonte, comece agora.',
    coldStartCta: 'Conectar fontes',
    /* Grupos de KPI */
    groupReach: 'Alcance e visibilidade',
    groupEngagement: 'Engajamento',
    groupGrowth: 'Crescimento',
    groupPaid: 'Midia paga',
    groupEfficiency: 'Eficiencia',
    /* Periodo visivel na area Digital */
    periodLabel: 'Periodo',
    /* Faixa informativa de periodo — abas Visao geral, Instagram, Meta Ads */
    periodBannerPrefix: 'Dados referentes ao período de',
    periodBannerCta: 'Clique aqui para selecionar um novo período',
    periodBannerCtaAriaLabel: 'Selecionar um novo período',
    periodBannerSuffix: '',
    periodLabel7d: '7 dias',
    periodLabel30d: '30 dias',
    periodLabel90d: '90 dias',
    periodLabel365d: '365 dias',
    /* Estado honesto de dado ausente */
    noDataForPeriod: 'Cross não tem os dados referentes ao período',
    noDataForPeriodSection: 'Cross não tem os dados referentes ao período',
  },
  fourPsNoData: {
    /* Alias semantico para uso no 4Ps/Painel — mesmo texto padrao do digital. */
    card: 'Cross não tem os dados referentes ao período',
    section: 'Cross não tem os dados referentes ao período',
  },
  report: {
    /* --- Cabecalho da tela --- */
    pageEyebrow: 'Relatorio {tipo} — {periodo}',
    pageTitleFallback: 'O que aconteceu no seu negocio em {periodo}.',
    pageMeta: 'Gerado em {dataGeracao} · {n} {fontePlural} · dados de {dataInicio} a {dataFim}',
    badgeWeekly: 'Semanal',
    badgeMonthly: 'Mensal',
    btnGenerate: 'Gerar novo relatorio',
    btnGenerating: 'Gerando...',

    /* --- Secoes do relatorio --- */
    sectionOpening: 'Esta semana',
    sectionOpeningMonthly: 'Este mes',
    sectionChanges: 'O que mudou',
    sectionGains: 'O que melhorou',
    sectionAttention: 'O que pede atencao',
    sectionActions: 'O que fazer agora',
    sectionSources: 'Origem dos numeros',
    sectionNoAlerts: 'Nada de relevante fora do comum esta semana.',
    sectionNoAlertsMonthly: 'Nada de relevante fora do comum este mes.',

    /* --- Historico de relatorios --- */
    historyLabel: 'Relatorios anteriores',
    historyEmpty: 'Nenhum relatorio gerado ainda.',
    historyItemWeekly: 'Semana de {dataInicio} a {dataFim}',
    historyItemMonthly: '{mes} {ano}',
    historyItemGeneratedAt: 'Gerado em {data}',
    historyItemView: 'Ver relatorio',

    /* --- Lista /reports --- */
    listTitle: 'Relatorios',
    listSubtitle: 'Cada relatorio e uma leitura completa do seu negocio em linguagem clara.',
    listFilterAll: 'Todos',
    listFilterWeekly: 'Semanal',
    listFilterMonthly: 'Mensal',
    listNew: 'Novo',
    listCardViewCta: 'Ver relatorio',

    /* --- Estados vazios --- */
    emptyFirstTimeTitle: 'O relatorio aparece aqui toda semana.',
    emptyFirstTimeBody:
      'O CROSS gera o primeiro relatorio em ate D+7 apos a primeira coleta completa. Enquanto isso, os numeros ja estao disponiveis no Painel e no Radar.',
    emptyFirstTimeCta: 'Ver painel de indicadores',
    emptyFirstTimeCta2: 'Ver radar de saude',

    emptyNoSourceTitle: 'Sem dados suficientes para este periodo.',
    emptyNoSourceBody:
      'O CROSS precisa de pelo menos uma fonte conectada para gerar o relatorio. Conectar o Instagram leva menos de 2 minutos.',
    emptyNoSourceCta: 'Conectar fontes',

    emptyPeriodTitle: 'Sem dados suficientes para este periodo.',
    emptyPeriodBody:
      'O CROSS nao encontrou dados coletados para {periodo}. Verifique se as fontes estao conectadas e se as planilhas do periodo foram enviadas ao Google Drive.',
    emptyPeriodBodyNoSource:
      'O CROSS precisa de pelo menos uma fonte conectada para gerar o relatorio. Conectar o Instagram leva menos de 2 minutos.',
    emptyPeriodCta: 'Ver fontes conectadas',
    emptyPeriodCtaNoSource: 'Conectar fontes',

    /* --- Loading --- */
    generatingLabel: 'O CROSS esta analisando seus dados...',
    generatingHint: 'Isso leva cerca de 30 segundos. Nao feche esta pagina.',
    generatingAria: 'Gerando relatorio narrativo. Aguarde cerca de 30 segundos.',

    /* --- Erros --- */
    errorTitle: 'Nao conseguimos gerar o relatorio agora.',
    errorBody:
      'Problema temporario. Seus dados estao salvos — o relatorio nao perdeu nenhuma informacao. Tente de novo em alguns minutos.',
    errorCta: 'Tentar de novo',
    errorCta2: 'Falar com o suporte',
    errorListTitle: 'Nao conseguimos carregar os relatorios.',
    errorListBody: 'Problema temporario. Tente de novo em alguns minutos.',

    rateLimitedTitle: 'Voce ja gerou um relatorio recentemente.',
    rateLimitedBody:
      'O CROSS precisa de um intervalo entre geracoes para garantir que os dados estejam atualizados. Tente novamente em {minutos} minuto{s}.',
    rateLimitedCta: 'Entendido',

    /* --- Detalhes do relatorio individual --- */
    backToList: 'Relatorios',
    generatedAt: 'Gerado em {data}',
    sourcesUsed: '{n} fonte{s}',
    periodRange: 'dados de {dataInicio} a {dataFim}',
    viewDashboard: 'ver todos os dados do periodo',
    verifySources: 'Verificar conexao das fontes',

    /* --- Bloco 2 — variacoes --- */
    changesDelta: '{delta} vs. {referencia}',
    changesNoData: '—',
    changesVsPrevious: 'vs. periodo anterior',
    changesVsAvg: 'vs. media das 4 semanas anteriores',

    /* --- Bloco 3 — analise narrativa --- */
    askCrossAboutAnalysis: 'Perguntar ao CROSS sobre esta analise',

    /* --- Bloco 4 — acoes --- */
    urgencyNow: 'Agora',
    urgencyThisWeek: 'Esta semana',
    urgencyNextMonth: 'Proximo mes',
    actionLinkView: 'Ver',
    actionAskCross: 'Perguntar ao CROSS',

    /* --- Bloco 5 — fontes --- */
    sourceGapNote: 'dados de {dataInicio} a {dataFim} ausentes por instabilidade da API.',

    /* --- Estado ia-unavailable --- */
    iaUnavailableTitle: 'A analise narrativa esta temporariamente indisponivel.',
    iaUnavailableBody:
      'As secoes "Por que importa" e "O que fazer" estao temporariamente indisponiveis. Os dados e variacoes do periodo estao corretos. Tente gerar a analise completa em alguns minutos.',
    iaUnavailableCta: 'Gerar analise agora',
    iaUnavailableGenerating: 'Gerando analise...',
    iaUnavailableErrorMsg:
      'Nao foi possivel gerar a analise agora. Tente mais tarde ou fale com o suporte.',
    iaUnavailableSupport: 'Falar com o suporte',

    /* --- Estado not-found --- */
    notFoundTitle: 'Relatorio nao encontrado.',
    notFoundBody: 'Este relatorio nao existe ou foi removido.',
    notFoundCta: 'Ver todos os relatorios',

    /* --- Estado ready-no-actions --- */
    noActionsMessage: 'Nenhuma acao urgente esta semana. Bom sinal.',

    /* --- Chip de periodo --- */
    periodPartial: 'Dados parciais — {source} sem dado de {dates}.',

    /* --- "Explica pra mim" --- */
    explainOpenAria: 'Explicar {metric}',
    explainCloseAria: 'Fechar explicacao',
    explainSourceNote: 'Dado de {source} · periodo {period}',
    explainGenericOpening:
      '{metric} e {definition}. No seu caso, o valor de {value} significa {practicalMeaning}.',
    explainCpcOpening:
      'CPC e o custo por clique — quanto o seu negocio pagou, em media, para cada pessoa que clicou no anuncio. Quanto mais baixo, mais eficiente o orcamento.',
    explainRoasOpening:
      'ROAS e o retorno sobre o investimento em anuncios — para cada R$ 1,00 gasto, quanto voltou em vendas rastreadas.',
    explainCtrOpening:
      'CTR e a taxa de cliques — de cada 100 pessoas que viram o anuncio, quantas clicaram.',
    explainReachOpening:
      'Alcance e o numero de pessoas unicas que viram pelo menos um conteudo neste periodo. Uma pessoa conta uma unica vez, independente de quantos posts ela viu.',
    explainEngagementOpening:
      'Engajamento e a soma de curtidas, comentarios e salvamentos nos posts do periodo.',
    explainRevenueOpening:
      'Faturamento e a receita bruta do periodo — a soma de todas as vendas antes de descontar custos.',
  },
  explain: {
    /* --- Painel "Explica pra mim" (F3-002) --- */
    panelTitle: 'O que e isso?',
    panelAriaLabel: 'Explicacao do indicador',
    closeBtnLabel: 'Fechar explicacao',

    /* Chips */
    kbChipLabel: 'Definicao curada',
    refChipLabel: 'Dado real',

    /* Secoes de conteudo */
    formulaLabel: 'Como e calculado:',
    benchmarkLabel: 'O que um bom resultado significa:',
    yourValueLabel: 'Seu {metric} agora:',
    sourceNote: 'Dado de {source} · periodo {period}',

    /* Estado: sem dados */
    noDataText: 'Sem dados para este periodo. Conecte uma fonte para ver seu valor real.',
    connectSourceCta: 'Conectar fonte',

    /* Estado: sem-definicao (404) */
    semDefinicaoText: 'Nao tenho a definicao desta metrica ainda. Pergunte ao CROSS.',

    /* Estado: error */
    errorText: 'Nao conseguimos carregar a explicacao. Tente de novo.',
    retryCta: 'Tentar de novo',

    /* CTAs */
    ctasLabel: 'Quer explorar mais?',
    askCrossCta: 'Perguntar ao CROSS sobre {metric}',
    viewHistoryCta: 'Ver historico no painel',

    /* Icone [?] no KpiCard */
    helpIconAriaLabel: 'Explicar {metric}',
  },
  metricNotices: {
    /* Alcance por video — descontinuado pela Meta em junho/2026 */
    instagramVideoReachTitle: 'Alcance por video desabilitado pela Meta',
    instagramVideoReachBody:
      'O alcance por video foi desabilitado pela Meta em junho/2026. O engajamento — curtidas e comentarios — segue integro e e a base da analise.',
  },
  analyzer: {
    /* Seletor de quantidade de posts */
    postLimitLabel: 'Posts analisados',
    postLimitAriaLabel: 'Quantidade de posts para analisar',
    postLimit10: '10 posts',
    postLimit25: '25 posts',
    postLimit50: '50 posts',
    postLimit100: '100 posts',
    /* Cabecalho de perfil */
    profileSection: 'Perfil do Instagram',
    profileCollectedAt: 'Coletado em {date}',
    profileFollowers: 'Seguidores',
    profileFollowing: 'Seguindo',
    profileMediaCount: 'Total de posts da conta',
    profileEngagement: 'Engajamento medio',
    profileAvgLikes: 'Curtidas medias',
    profileAvgComments: 'Comentarios medios',
    profileAvgReach: 'Alcance medio por post',
    profileAvgSaves: 'Salvamentos medios',
    profileAvgShares: 'Compartilhamentos medios',
    profileFrequency: 'Posts por semana',
    profileBestDay: 'Melhor dia para postar',
    /* Notas honestas */
    insightsUnavailableNote:
      'Alcance, salvamentos e compartilhamentos por post podem vir zerados — a conta nao concedeu a permissao instagram_manage_insights nesta conexao.',
    videoReachNote:
      'Alcance por video vem 0 da Meta desde junho/2026 (descontinuacao). O engajamento (curtidas + comentarios) permanece integro e e a base das comparacoes.',
    /* Hashtags */
    hashtagsSection: 'Hashtags mais usadas',
    hashtagUsed: 'usada {count} vez',
    hashtagUsedPlural: 'usada {count} vezes',
    /* Distribuicao de conteudo */
    contentDistSection: 'Distribuicao de conteudo',
    contentDistUnit: 'post',
    contentDistUnitPlural: 'posts',
    /* Desempenho por formato */
    formatPerfSection: 'Desempenho por formato',
    formatPerfBest: 'Melhor formato',
    formatPerfBestLabel: 'Melhor engajamento',
    formatPerfBestNull:
      'Amostra insuficiente para eleger o melhor formato (minimo 2 posts por tipo).',
    formatPerfCount: '{count} post',
    formatPerfCountPlural: '{count} posts',
    formatPerfEngagement: 'Engajamento medio',
    formatPerfEngagementCol: 'Eng. medio',
    formatPerfReach: 'Alcance medio',
    formatPerfReachCol: 'Alcance med.',
    formatPerfSaves: 'Salvamentos medios',
    formatPerfSavesCol: 'Salvamentos',
    formatPerfLikes: 'Curtidas medias',
    formatPerfLikesCol: 'Curtidas med.',
    formatPerfFormatCol: 'Formato',
    formatPerfCountCol: 'Posts',
    /* Posts recentes */
    postsSection: 'Posts recentes',
    postsLoading: 'Carregando posts...',
    postsError: 'Nao foi possivel carregar os posts. Tente novamente.',
    postsEmpty: 'Nenhum post encontrado.',
    postLikes: 'Curtidas',
    postComments: 'Comentarios',
    postReach: 'Alcance',
    postSaves: 'Salvamentos',
    postEngagement: 'Engajamento',
    postViewOnInstagram: 'Ver no Instagram',
    postNoCaption: 'Sem legenda',
    /* Parecer da IA */
    reportSection: 'Parecer do CROSS Flux',
    reportGenerate: 'Gerar parecer do CROSS Flux',
    reportGenerating: 'O CROSS Flux esta analisando seu perfil...',
    reportGeneratingHint: 'Isso pode levar cerca de 40 segundos. Nao feche esta pagina.',
    reportScore: 'Score de desempenho',
    reportScoreLabel: 'de 100',
    reportSummary: 'Resumo',
    reportStrengths: 'Pontos fortes',
    reportWeaknesses: 'Pontos de atencao',
    reportRecommendations: 'Recomendacoes',
    reportContentStrategy: 'Estrategia de conteudo',
    reportGeneratedAt: 'Gerado em {date}',
    reportError: 'Nao foi possivel gerar o parecer agora. Tente novamente.',
    reportRateLimit: 'Voce ja gerou um parecer recentemente. Aguarde um momento e tente de novo.',
    reportRetry: 'Tentar novamente',
    /* Estados da aba */
    loadingProfile: 'Carregando perfil do Instagram...',
    errorNoSource: 'Conta Instagram nao conectada',
    errorNoSourceDesc:
      'Conecte uma conta de Instagram em Fontes para ver a analise de desempenho aqui.',
    errorNoSourceCta: 'Conectar Instagram',
    errorNotConnected: 'Sua conta de Instagram precisa ser reconectada',
    errorNotConnectedDesc:
      'A conexao com o Instagram esta inativa. Reconecte em Fontes para retomar a coleta.',
    errorNotConnectedCta: 'Reconectar em Fontes',
    errorCollect: 'Nao foi possivel coletar os dados do Instagram agora. Tente novamente.',
    errorRetry: 'Tentar novamente',
    /* Labels de formato */
    formatImage: 'Imagem',
    formatVideo: 'Video',
    formatCarousel: 'Carrossel',
    formatReel: 'Reel',
    formatOther: 'Outro',
  },
  ads: {
    /* Cabecalhos e meta */
    listTitle: 'Campanhas Meta Ads',
    listSubtitle: 'Suas campanhas ativas e pausadas, uma por uma.',
    listAccountLabel: 'Conta',
    listLastCollected: 'Ultima coleta',
    summaryTitle: 'Resumo da conta',
    summarySpend: 'Investimento total',
    summaryClicks: 'Cliques',
    summaryCpc: 'CPC medio',
    summaryVia: 'via Meta Ads',
    viewCampaigns: 'Ver campanhas por separado',
    /* Filtros */
    filterPeriod: 'Periodo',
    filterStatus: 'Status',
    filterStatusAll: 'Todas',
    filterStatusActive: 'Ativas',
    filterStatusPaused: 'Pausadas',
    filterSort: 'Ordenar por',
    filterSortSpend: 'Investimento',
    filterSortClicks: 'Cliques',
    filterSortCpc: 'CPC',
    filterSortCtr: 'CTR',
    filterSortName: 'Nome',
    /* Tabela de lista */
    colName: 'Campanha',
    colStatus: 'Status',
    colSpend: 'Investimento',
    colClicks: 'Cliques',
    colCpc: 'CPC',
    colCtr: 'CTR',
    colImpressions: 'Impressoes',
    colRoas: 'ROAS',
    viewCampaign: 'Ver campanha',
    selectCompare: 'Selecionar para comparar',
    deselectCompare: 'Remover da comparacao',
    /* Status de campanha */
    statusActive: 'Ativa',
    statusPaused: 'Pausada',
    statusArchived: 'Arquivada',
    statusInReview: 'Em revisao',
    statusUnknown: 'Desconhecido',
    /* Barra de comparacao */
    compareBarSingle: '1 campanha selecionada',
    compareBarPlural: '{count} campanhas selecionadas',
    compareNow: 'Comparar agora',
    clearSelection: 'Limpar selecao',
    compareMaxTooltip: 'Maximo de 3 campanhas para comparar. Remova uma para adicionar outra.',
    /* Detalhe de campanha */
    detailTitle: 'Campanha',
    detailSource: 'Meta Ads',
    detailStatus: 'Status',
    detailObjective: 'Objetivo',
    detailCreated: 'Criada em',
    detailAccount: 'Conta',
    detailId: 'ID',
    detailLastCollected: 'Ultima coleta',
    kpisTitle: 'KPIs desta campanha',
    kpiSpend: 'Investimento',
    kpiClicks: 'Cliques',
    kpiCpc: 'CPC',
    kpiCtr: 'CTR',
    kpiImpressions: 'Impressoes',
    kpiRoas: 'ROAS',
    kpiCpm: 'CPM',
    kpiVia: 'via Meta Ads',
    kpiCalculated: 'Calculado',
    kpiNoData: 'Sem dados para este periodo.',
    kpiNoDataWhy: 'Por que?',
    kpiNoDataExplain: 'Esta campanha nao tinha dados coletados neste periodo.',
    roasNull: '—',
    roasNullExplain: 'Rastreamento de conversao nao configurado no Meta Ads.',
    roasNullLearn: 'Saiba o que e isso',
    roasNullDetail:
      'O ROAS so e calculado quando o pixel do Meta esta instalado no site do negocio e rastreando conversoes. Sem o pixel configurado, nao ha como atribuir receita aos anuncios.',
    compareWith: 'Comparar com outra campanha',
    askCross: 'Perguntar ao CROSS sobre esta campanha',
    crossInsightTitle: 'O que o CROSS Flux diz sobre esta campanha',
    crossInsightRef: 'via Meta Ads',
    crossAskMore: 'Perguntar mais sobre esta campanha ao CROSS',
    /* Comparacao */
    compareTitle: 'Comparando campanhas',
    compareTitleCount: 'Comparando {count} campanhas',
    compareMetric: 'Metrica',
    compareAddCampaign: 'Adicionar campanha',
    compareRemove: 'Remover da comparacao',
    compareInsightTitle: 'O que o CROSS Flux diz sobre esta comparacao',
    compareAskMore: 'Perguntar mais sobre esta comparacao ao CROSS',
    compareChartClicks: 'Cliques ao longo do periodo',
    compareChartCpc: 'CPC ao longo do periodo',
    compareSingleRedirect: 'Redirecionando para o detalhe da campanha...',
    /* Ref chip */
    refChipLabel: 'Meta Ads',
    refChipVia: 'via Meta Ads',
    refPanelTitle: 'Origem do dado',
    refPanelMetric: 'Metrica',
    refPanelSource: 'Fonte',
    refPanelAccount: 'Conta',
    refPanelCampaign: 'Campanha',
    refPanelPeriod: 'Periodo coletado',
    refPanelLastUpdate: 'Ultima atualizacao',
    refPanelClose: 'Fechar',
    /* Empty states */
    emptyNoSource: 'Nenhuma campanha para mostrar.',
    emptyNoSourceDesc: 'O Meta Ads nao esta conectado a esta conta.',
    emptyNoSourceHint: 'Para ver suas campanhas aqui, conecte o Meta Ads. Leva menos de 2 minutos.',
    emptyNoSourceCta: 'Conectar Meta Ads',
    emptyNoCampaigns: 'Nenhuma campanha ativa neste periodo.',
    emptyNoCampaignsDesc:
      'Pode ser que nao havia campanhas rodando neste periodo, ou que a coleta ainda nao pegou os dados.',
    emptyNoCampaignsCta: 'Ampliar o periodo',
    emptyNoCampaignsVerify: 'Verificar conexao',
    emptyNoCampaignsBack: 'Voltar ao painel',
    /* Erro */
    errorTitle: 'Nao conseguimos buscar as campanhas agora.',
    errorDesc: 'Pode ser uma instabilidade temporaria.',
    errorRetry: 'Tentar de novo',
    errorSupport: 'Falar com o suporte',
    /* Campanha nao encontrada */
    notFoundTitle: 'Campanha nao encontrada.',
    notFoundDesc: 'Esta campanha nao existe ou foi removida da conta de anuncios.',
    notFoundCta: 'Ver todas as campanhas',
    /* Navegacao */
    backToCampaigns: 'Campanhas',
    backToDashboard: 'Voltar ao painel',
    backToTraffic: 'Trafego',
    /* Periodos */
    period30d: 'Ultimos 30 dias',
    period7d: 'Ultimos 7 dias',
    period90d: 'Ultimos 90 dias',
    period365d: 'Ultimos 12 meses',
  },
} as const;

type Leaves<T> =
  T extends Record<string, unknown>
    ? {
        [K in keyof T]: T[K] extends string
          ? `${K & string}`
          : `${K & string}.${Leaves<T[K]> & string}`;
      }[keyof T]
    : never;

export type TranslationKey = Leaves<typeof ptBR>;

/**
 * Lookup type-safe por caminho pontuado.
 * Lanca em dev se a chave nao existir (tipo-seguro em build impede isso).
 *
 * Interpolacao: passe `params` para substituir `{chave}` na string.
 * Ex: t('drivePicker.folderSelectedLabel', { nome: 'Vendas' })
 * -> 'Pasta selecionada: Vendas'
 */
export function t(key: TranslationKey, params?: Record<string, string>): string {
  const parts = key.split('.');
  let cur: unknown = ptBR;
  for (const p of parts) {
    if (cur && typeof cur === 'object' && p in (cur as Record<string, unknown>)) {
      cur = (cur as Record<string, unknown>)[p];
    } else {
      return key;
    }
  }
  let result = typeof cur === 'string' ? cur : key;
  if (params !== undefined) {
    for (const [k, v] of Object.entries(params)) {
      result = result.replaceAll(`{${k}}`, v);
    }
  }
  return result;
}
